import './home.css';
import CreateSession from '../mirror-cast/session/create';
import MarquardtViewer from './marquardt/viewer';
import {AboutButton,AboutPage} from '../about/about';
import { useState } from 'react';

const PhiHome = () => {
  const [aboutReady, setAboutReady] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const vitruvianUrl =
    process.env.REACT_APP_STAGING === 'dev'
      ? 'https://dev.phi-vitruvian.co'
      : 'https://phi-vitruvian.co';

const toggleAbout = () => {
  setShowAbout(v => !v);
  if (!showAbout) {
    setTimeout(() => {
      setAboutReady(true);
    }, 800);
  }
};

  return (
    <div className={`phi-home-container ${showAbout ? 'about-active' : ''}`}>
      <div className={`phi-pages ${showAbout ? 'about' : ''}`}>
        <section className='phi-home'>
          <div className='phi-home-marquardt'>
            <MarquardtViewer />
          </div>

          <div className='phi-home-menu'>
            <div className='phi-home-menu-item'>
              <div className='phi-home-menu-index'>1:</div>
              <a
                className='phi-home-button-vitruvian'
                href={vitruvianUrl}
                rel='noopener noreferrer'
                target='_blank'
              >
                - Vitruvian -
              </a>
            </div>

            <div className='phi-home-menu-item'>
              <div className='phi-home-menu-index'>2:</div>
              <button
                className='phi-home-button-mirrorcast'
                onClick={CreateSession}
                to="/mirror-cast"
              >
                - Mirror Cast - 
              </button>
              <a className='phi-home-button-beta'>
                ( BETA )
              </a>
            </div>
          </div>
        </section>
        <section
          className='phi-about'
        >
          <AboutPage
            show={aboutReady}
          />
        </section>
      </div>
      <AboutButton
        show={showAbout}
        toggle={toggleAbout}
      />
    </div>
  );
};

export default PhiHome;